import React from 'react';
import { RankStatusHero } from './RankStatusHero';
import { Roadmap } from './Roadmap';
import { OfficerData } from '../data/officers';
interface CareerViewProps {
  officer: OfficerData;
}
export function CareerView({
  officer
}: CareerViewProps) {
  return <div className="space-y-6" data-id="element-156">
      <RankStatusHero officer={officer} data-id="element-157" />
      <Roadmap data-id="element-158" />
    </div>;
}